import { render, staticRenderFns } from "./AlbumShowMoreBtn.vue?vue&type=template&id=001c1344&scoped=true&"
import script from "./AlbumShowMoreBtn.vue?vue&type=script&lang=js&"
export * from "./AlbumShowMoreBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001c1344",
  null
  
)

export default component.exports